import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";

const Spinner = ({ waitingTime = 60000 }) => {
  const [showSpinner, setShowSpinner] = useState(true);

  // Set Time Out
  useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(false), waitingTime);   
    return () => {  
      if (timer === waitingTime) {
        toast.error("An error occurred.", { autoClose: false });
        console.error(timer, waitingTime);
      } 
      clearTimeout(timer);
    };
  });

  return (
    <>
      {showSpinner && (
        <div style={{ position: "absolute", top: "50%", left: "50%" }}>
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default Spinner;
